export default {
  hello: '你好',
  i18n_home: '首页',
  i18n_Tracking: '轨迹',
  i18n_Check_Pricing_and_order: '查价下单',
  i18n_Return: '返回',
  i18n_Order_info: '委托信息',
  i18n_Tracking_number: '运单号',
  i18n_destination: '目的仓库',
  i18n_Original_Port: '起运地',
  i18n_Order_date: '委托日期',
  i18n_arrived_warehouse_date: '入仓日期',
  i18n_Shipping_method: '运输方式',
  i18n_Package_info: '收货信息',
  i18n_Please_ship_your_package_to_below_warehouse: '请将货物送至以下仓库',
  i18n_Forecast_pakcage_info: '商品预报信息',
  i18n_Accurated_package_info: '商品入仓信息',
  i18n_Serial_number: '序号',
  i18n_FBA_number: '箱号',
  i18n_Cititrans_Tracking_number: '亦邦箱号',
  i18n_box_counting_number: '箱序',
  i18n_Amazon_Reference_Number_PO: '货件追踪号',
  i18n_cargo_classification: '货物类型',
  i18n_weight_kgs: '重量(kgs)',
  i18n_weight: '重量',
  i18n_volume_cbm: '体积(cbm)',
  i18n_size_cm: '尺寸(cm)',
  i18n_sku_number: 'SKU数',
  i18n_Operation: '操作',
  i18n_view_details: '查看详情',
  i18n_view_pictures: '查看图片',
  i18n_view_tracking: '查看轨迹',
  i18n_shipping_fee_info: '费用信息',
  i18n_cost_category: '费用项',
  i18n_estimated_cost: '预估费用',
  i18n_actual_cost: '实际费用',
  i18n_tracking_info: '轨迹信息',
  i18n_download_labels: '下载标签',
  i18n_Contact_hotline: '全国客服热线',
  i18n_online_chat: '在线客服',
  i18n_contact_us: '联系我们',
  i18n_mini_program: '小程序',
  i18n_back_to_the_top: '返回顶部',
  i18n_Clients_tracking_number: '客户单号',
  i18n_started_date: '开始时间',
  i18n_end_date: '结束时间',
  i18n_delete: '删除',
  i18n_Cost: '我的费用',
  i18n_cost_generated_time: '费用产生时间',
  i18n_bill_status: '费用状态',
  i18n_please_choose: '请选择',
  i18n_pay: '支付',
  i18n_combine_payments: '合并支付',
  i18n_fee_details: '费用详情',
  i18n_Logistics_Product: '物流产品',
  i18n_Please_choose_original_wareohuse: '请选择起运地仓库',
  i18n_please_choose_your_destination: '请选择目的地',
  i18n_Create_new_product: '商品新增',
  i18n_Product_name_in_Chinese: '中文品名',
  i18n_brands: '品牌',
  i18n_HTS_code: '海关编码',
  i18n_Material_in_Chinese: '中文材质',
  i18n_Material_in_English: '英文材质',
  i18n_Product_uses_in_Chinese: '中文用途',
  i18n_electric_or_not: '是否带电',
  i18n_yes: '是',
  i18n_no: '否',
  i18n_product_name_in_English: '英文品名',
  i18n_product_value: '货值(USD)',
  i18n_product_value1: '货值',
  i18n_material_in_English: '英文材质',
  i18n_Product_uses_in_English: '英文用途',
  i18n_liquid_power_or_not: '是否液体/粉末',
  i18n_Create_new_address: '新增地址',
  i18n_contact_person: '联系人',
  i18n_contact_info: '联系方式',
  i18n_contact_address: '联系地址',
  i18n_please_type_your_name: '请输入姓名',
  i18n_please_type_the_contact_info: '请输入联系方式',
  i18n_please_enter_the_detailed_location: '请输入详细地址',
  i18n_shipper: '发货人',
  i18n_new_shipper_address: '新增发货地址',
  i18n_receiver: '收货人',
  i18n_pick_up_party: '提货人',
  i18n_edit: '编辑',
  // i18n_delete: '删除',
  i18n_tracking_terms_selction: '轨迹推送',
  i18n_full_container_load: '整柜',
  i18n_Marine_bulk_cargo: '海运散货',
  i18n_International_Air_Freight: '国际空运',
  i18n_FBA: '电商',
  i18n_All: '全部',
  i18n_waiting_for_payment: '待支付',
  i18n_waiting_for_confirmation: '待确认',
  i18n_completed: '已完成',
  i18n_partial_payment: '部分支付',
  i18n_payment_processing: '支付中',
  i18n_Total_payment: '合计',
  i18n_Covert_to_CNY: '折合人民币',
  i18n_no_tracking_status_yet: '暂无轨迹信息',
  i18n_more_tracking_status: '更多轨迹',
  i18n_click_and_download_labels: '点击下载标签',
  i18n_FBA_order: 'FBA订单',
  i18n_please_enter: '请输入',
  i18n_PO_number: 'PO号',
  i18n_receving_warehosue: '入仓仓库',
  i18n_shipment_arrival_time: '入仓时间',
  i18n_Inquiry: '查询',
  i18n_destined_country: '目的国家',
  i18n_destined_isChoseSafe: '是否投保',
  i18n_shipment_information: '货物信息',
  i18n_Cancel: '作废',
  i18n_Charge_category: '费用类型',
  i18n_Price: '价格',
  // i18n_Index_title: '中东·非洲跨境综合物流头部品牌',
  i18n_Index_title: '新兴市场跨国综合物流服务商',
  i18n_Index_title_l: '中东|拉美|非洲|东南亚',
  i18n_track_status: '查轨迹',
  i18n_Country_shipment_type: '国家/货物类型',
  i18n_confirm_addition: '确认新增',
  i18n_confirm_revision: '确认修改',
  i18n_set_to_default: '设为默认',
  i18n_default_address: '默认地址',
  i18n_label: '标签',
  i18n_set_to_default_address: '设置为默认地址',
  i18n_add: '新增',
  // i18n_edit: '修改',
  i18n_edit_successfully: '修改成功',
  i18n_added_successfully: '新增成功',
  i18n_delete_address_tip: '此操作将删除该地址, 是否继续?',
  i18n_hint: '提示',
  i18n_confirm: '确定',
  i18n_cancel: '取消',
  i18n_contact_person_cant_be_empty: '联系人不能为空！',
  i18n_contact_number_incorrect: '手机号码有误，请重填',
  i18n_label_cannot_exceeds_5_characters: '标签长度不能超过五个字符',
  i18n_new_recevier_address: '新增收货地址',
  i18n_recevier_address: '收货地址',
  i18n_new_pickup_address: '新增提货地址',
  i18n_pickup_address: '提货地址',
  i18n_account_login: '账号登录',
  i18n_phone_number_login: '手机登录',
  i18n_enter_account: '请输入账号/邮箱',
  i18n_please_enter_your_password: '请输入密码',
  i18n_login: '登 录',
  i18n_forget_password: '忘记密码',
  i18n_sign_up: '注册',
  i18n_tick_term: '我已阅读并同意',
  i18n_seperate: "、",
  i18n_terms_service: '《服务条款》',
  i18n_shipping_terms: "《运输条款》",
  i18n_entrustment_agreement: '《委托贸易代理出口协议》',
  i18n_and: "和",
  i18n_citi_term: '亦邦物流用户服务条款',
  i18n_transform_term: '亦邦物流运输条款与条件',
  i18n_Personal_Center: '个人中心',
  i18n_Log_out: '退出',
  i18n_Please_enter_your_name: '请输入名称',
  i18n_Please_enter_you_phone_number: '请输入手机号码',
  i18n_please_confirm_password: '请输入确认密码',
  i18n_please_enter_verification_code: '请输入验证码',
  i18n_I_have_been_read: '我已阅读',
  i18n_Sign_up_Now: '立即注册',
  i18n_Personal_Account: '个人用户',
  i18n_Name: '姓名',
  i18n_Confirm_Password: '确认密码',
  i18n_Password: '密码',
  i18n_SMS_Verification_Code: '短信验证码',
  i18n_Receive_SMS_verification_code: '获取验证码',
  i18n_Business_Account: '企业用户',
  i18n_Please_enter_your_business_name: '请输入公司名称',
  i18n_Internation_User: '海外用户',
  i18n_please_enter_your_working_email: '请输入工作邮箱',
  i18n_Please_enter_your_contact_number: '请输入联系电话',
  i18n_Please_enter_your_contact_correct_number: '请输入正确的联系电话',
  i18n_Please_enter_your_Dubai_contact_correct_number: '请输入正确的迪拜联系电话',
  i18n_fee_exception: '费用为0，请核实',
  i18n_tiHuo_fee_exception: '提货费费用为0，请核实',
  i18n_weight_limit: '重量限制在30KG',
  i18n_length_limit: '长度限制在1.2M',
  i18n_width_limit: '宽度限制在1.2M',
  i18n_height_limit: '高度限制在1.2M',
  i18n_email_verification_code: '邮箱验证码',
  i18n_Please_enter_the_order_number_to_inquire: '请输入单号查询',
  i18n_Please_enter_correct_cell_phone_number: '请输入正确的手机号码',
  i18n_Please_agree_to_service_agreement_first: '请先同意服务协议!',
  i18n_Login_successful: '登录成功',
  i18n_Please_enter_phone_number_or_verification_code: '请输入手机号或验证码',
  i18n_Please_enter_your_email_password: '请输邮箱或密码',
  i18n_Verification_code_has_been_sent: '验证码已发送',
  i18n_Please_send_again_after_second: '请{countDown}秒后再发送',
  i18n_two_entered_passwords_do_not_match: '两次输入的密码不一致',
  i18n_phone_number_cannot_be_empty: '电话号码不能为空',
  i18n_Incorrect_phone_number_format: '电话号码格式不正确',
  i18n_Please_enter_numbers: '请输入数字',
  i18n_Mailbox_cannot_be_empty: '邮箱不能为空',
  i18n_Please_enter_correct_email_format: '请输入正确的邮箱格式',
  i18n_Registration_successful_Please_login: '注册成功！请登录',
  i18n_Sure_to_exit_and_return: '确定退出并返回吗?',
  i18n_Canceled: '已取消',
  i18n_Quick_Login: '快速登录',
  i18n_magnetic_or_not: '是否带磁',
  i18n_Full_container_load: '海运整柜',
  i18n_entrust_information: '委托信息',
  i18n_entrusting_company: '委托公司',
  i18n_clearance_metods: '清关方式',
  i18n_self_clearing: '自清',
  i18n_Cititran_incharges_of_double_clearing: '亦邦双清',
  i18n_destination_city: '目的城市',
  i18n_contact_number: '联系电话',
  i18n_pay_party: '付款方',
  i18n_domestic_payment: '国内付款',
  i18n_foreign_payment: '国外付款',
  i18n_warehouse_received_time: '入仓时间',
  i18n_origin_port: '起运地',
  i18n_logistics_services: '物流产品',
  i18n_receive_warehouse_number: '获取入仓号',
  i18n_estimated_receiving_time: '预计入仓时间',
  i18n_location_information: '地址信息',
  i18n_consignee_information: '收货信息',
  i18n_shipper_information: '发货信息',
  i18n_door_to_door_pickup_service: '是否需要上门取件',
  i18n_Collapse: '收起',
  i18n_Search: '搜索',
  i18n_Close: '关闭',
  i18n_Phone: '电话',
  i18n_Default: '默认',
  i18n_Detailed_address: '详细地址',
  i18n_Modify_Address: '修改地址',
  i18n_Phone_number: '手机号',
  i18n_no_more_than_20_characters: '不能超过20位',
  i18n_product_information: '商品信息',
  i18n_product_name: '品名',
  i18n_product_name_cn: '品名(CN)',
  i18n_product_name_en: '品名(EN)',
  i18n_elestric: '带电',
  i18n_liquid_powder: '液体粉末',
  i18n_carton_count: '箱数',
  i18n_single_box: '单箱',
  i18n_pcs_count: '件数',
  i18n_length: '长(cm)',
  i18n_wide: '宽(cm)',
  i18n_height: '高(cm)',
  i18n_length1: '长',
  i18n_wide1: '宽',
  i18n_height1: '高',
  i18n_add_product: '添加商品',
  i18n_product_type: '货物类型',
  i18n_lwh: '长宽高(cm)',
  i18n_volume: '体积(cbm)',
  i18n_total_weight: '总重量(kg)',
  i18n_total_volume: '总体积(cbm)',
  i18n_total_volume1: '总体积',
  i18n_Total: '合计',
  i18n_trade_information: '贸易信息',
  i18n_customs_declaration_with_Agent_license: '买单报关',
  i18n_customs_declaration_with_tax_refund: '退税报关',
  i18n_remark: '备注',
  i18n_delivery_remark: '发货备注',
  i18n_pickup_remark: '提货备注',
  i18n_submit_order: '提交订单',
  i18n_upload_clearance_documents: '上传报关资料',
  i18n_warehouse_number: '入仓号',
  i18n_cannot_be_empty: '不能为空',
  i18n_Success: '成功',
  i18n_File_upload_failed: '文件上传失败',
  i18n_Upload_up_to_one_file: '最多上传一个文件',
  i18n_File_uploaded_successfully: '文件上传成功',
  i18n_Please_add_products: '请添加商品',
  i18n_label: '唛头',
  i18n_LTL_order: '海运散货订单',
  i18n_tracking_number: '运单号',
  i18n_delivery_area: '配送区域',
  i18n_tracking: '查询',
  i18n_creation_time: '创建时间',
  i18n_International_Air_mail_order: '国际空运订单',
  i18n_Pieces: '件',
  i18n_Destination: '目的地',
  i18n_Warehouse: '仓库',
  i18n_Payment_Method: '支付方式',
  i18n_Product_Name: '商品名称',
  i18n_Product_Images: '商品图片',
  i18n_No_data: '暂无数据',
  i18n_Fee_Name: '费用名称',
  i18n_Amount_receivable: '应收金额',
  i18n_Amounts_payable: '应付金额',
  i18n_WeChat_Pay: '微信支付',
  i18n_Alipay_payment: '支付宝支付',
  i18n_Pay_Now: '立即支付',
  i18n_Payment_Remaining_Time: '支付剩余时间',
  i18n_minutes: '分',
  i18n_seconds: '秒',
  i18n_Confirmation_closure: '确认关闭？',
  i18n_select_payment_method: '请先选择支付方式',
  i18n_Payment_success_jumping: '支付成功,正在跳转..',
  i18n_my_bills: '我的账单',
  i18n_invoice_number: '账单号',
  i18n_tracking_number: '单号',
  i18n_Payment_amount: '支付金额',
  i18n_Payment_Time: '支付时间',
  i18n_No_of_picture: '第 {count} 张图片',
  i18n_Rotation: '旋转',
  i18n_Enlarge: '放大',
  i18n_zoom_out: '缩小',
  i18n_already_biggest: '已经是最大了',
  i18n_already_smallest: '已经是最小了',
  i18n_account_management: '用户管理',
  i18n_change_password: '修改密码',
  i18n_old_password: '旧密码',
  i18n_new_password: '新密码',
  i18n_confirm_password: '确认密码',
  i18n_confirm_edit: '确定修改',
  i18n_change_contact_number: '更改手机号',
  i18n_old_contact_number: '当前手机号',
  i18n_new_contact_number: '新手机号',
  i18n_verification_code: '验证码',
  i18n_code_or_phone_empty: '验证码或手机号不能为空',
  i18n_phone_error: '手机号码有误，请重填',
  i18n_change_phone_success: '修改手机号成功',
  i18n_password_cannot_empty: '密码不能为空！',
  i18n_Confirm_password_different: '确认密码不一样！',
  i18n_sub_account_management: '子账号管理',
  i18n_account: '账号',
  i18n_usage_status: '使用状态',
  i18n_Enable: '启用',
  i18n_Disable: '停用',
  i18n_create_new_sub_account: '新建子账号',
  i18n_User_Name: '用户名',
  i18n_Roles: '角色',
  i18n_Is_main_account: '是否主账号',
  i18n_Create_new_sub_account: '新建子账号',
  i18n_Modify_sub_account: '修改子账号',
  i18n_Employee_Name: '员工姓名',
  i18n_Email: '邮箱',
  i18n_Status: '状态',
  i18n_Confirm_continue: '确认并继续新建',
  i18n_Confirm: '确认',
  i18n_Please_enter_your_password_again: '请再次输入密码',
  i18n_role_management: '角色管理',
  i18n_create_new_role: '新建角色',
  i18n_role_name_in_chinese: '角色中文名',
  i18n_role_name_in_English: '角色英文名',
  i18n_View_permissions: '查看权限',
  i18n_Permission_assignment: '权限分配',
  i18n_Modify_Role: '修改角色',
  i18n_Corresponding_permissions: '对应权限',
  i18n_select_all_permissions: '选择所有权限',
  i18n_destination_country: '目的国',
  i18n_refresh: '刷新',
  i18n_batch_query: '批量查询',
  i18n_Business_Type: '业务类型',
  i18n_Drag_file_here_or: '将文件拖到此处，或',
  i18n_click_Upload: '点击上传',
  i18n_xls_files_only: '仅限xls文件',
  i18n_xls_xlsx_files_only: '仅限xls和xlsx文件',
  i18n_Download_Template: '下载模板',
  i18n_New_Products: '新增商品',
  i18n_Importing_Products: '导入商品',
  i18n_Country: '国家',
  i18n_Uses: '用途',
  i18n_xls_and_xlsx_only: '仅限xls和xlsx文件',
  i18n_Number_of_rows: '行数',
  i18n_Is_it_successful: '是否成功',
  i18n_Failure: '失败',
  i18n_Description: '描述',
  i18n_delete_goods_tip: '确定删除此商品信息吗, 是否继续?',
  i18n_acility_delivery_booking_management: '约仓管理',
  i18n_import_delivery_booking_document: '导入约仓文件',
  i18n_Box_number: '箱号',
  i18n_Go_to_Order: '去下单',
  i18n_Price_Details: '价格详情',
  i18n_Shipping_Instructions: '发货说明',
  i18n_Air_Freight_Information: '空运信息',
  i18n_Copy: '复制',
  i18n_fba_example: '示例：FBAXXXXX',
  i18n_reference_example: '示例：618T8E8X',
  i18n_Example_diagram: '示例图',
  i18n_product_number: '{num}件商品',
  i18n_quantity: '数量',
  i18n_Select_product: '选择商品',
  i18n_New_box: '新增箱子',
  i18n_Kilometers: '公里',
  i18n_Previousstep: '上一步',
  i18n_Next_step: '下一步',
  i18n_name_or_phone_number: '请输入姓名或电话',
  i18n_Product_List: '商品列表',
  i18n_Product_Type: '商品类型',
  i18n_Error_Description: '错误描述',
  i18n_Length_of_characters: '长度只能为{num}个字符',
  i18n_Numbers_letters_only: '只能为数字和字母',
  i18n_Must_start_with_FBA: '必须以FBA开头',
  i18n_more_than0_two_decimal: '大于零且保留最多三位小数',
  i18n_more_than0_two_decimal2: '货值大于零且保留最多三位小数',
  i18n_Product_Templates: '商品模板',
  i18n_Deleted_successfully: '删除成功',
  i18n_Products: '商品',
  i18n_Only_same_type: '单箱内只能放入同一种货物类型',
  i18n_No_more_3_in_one_box: '单箱子内商品类型不能超过3件',
  i18n_add_product_in_box: '请添加{no}号箱子内商品信息',
  i18n_duplicate_box_numbers: '箱号存在重复请检查',
  i18n_number_of_products_cannot_0: '添加的商品数量不能为0',
  i18n_Already_default_address: '已经是默认地址',
  i18n_Please_fill_box_information: '请填充完整箱子信息',
  i18n_Sure_delete: '确定要删除吗？',
  i18n_status_is_edit_close: '当前为编辑状态,是否关闭?',
  i18n_fill_correct_price: '请填写正确的价格',
  i18n_Shipper_Information: '发货人信息',
  i18n_Add_consignor: '新增发货人',
  i18n_No_default_contact: '暂无默认联系人请添加',
  i18n_No_contact: '暂无联系人请添加',
  i18n_Order_Information: '订单信息',
  i18n_Total_weight: '总重量',
  i18n_Total_pieces: '总件数',
  i18n_Total_boxes: '总箱数',
  i18n_Boxes: '箱',
  i18n_Carriage_goods_agreement: '货物运输协议',
  i18n_select_or_add_shipper: '请选择或添加发货人信息',
  i18n_complete_receive_information: '请将收货人信息补充完整',
  i18n_complete_sender_information: '请将发货人信息补充完整',
  i18n_agree_agreement_first: '请先同意协议',
  i18n_Failed_to_get: '获取失败',
  i18n_Box_Details: '箱子详情',
  i18n_product_quantity: '产品数量',
  i18n_Are_your_confirm_order: '您确认委托下述商品吗？',
  i18n_confirmed_enter_warehouse: '您确认委托入仓吗？',
  i18n_confirm_order: '确认委托',
  i18n_order_completed: '委托完成',
  i18n_waiting_shipment_to_warehoused: '等待货物入仓',
  i18n_track_order: '查看订单',
  i18n_continue_to_order: '继续下单',
  i18n_more_contact_information: '更多联系人信息',
  i18n_pickup_location: '提货地点',
  i18n_address_book: '地址簿',
  i18n_pickup_person: '提货人',
  i18n_pickup_contact_number: '提货电话',
  i18n_pickup_time: '提货时间',
  i18n_send_goods_to_following_address: '请将货物送到以下地址',
  i18n_Warehouse_Address: '仓库地址',
  i18n_cost_calculation: '费用计算',
  i18n_shipping_cost: '运费',
  i18n_global_delivery_cost: '尾程派送费',
  i18n_pickup_fee: '提货费',
  i18n_ocean_freight_cost: '海运费',
  i18n_pickup_at_original_port: '发货地上门提货',
  i18n_total_cost: '合计费用',
  i18n_subtotal: '小计',
  i18n_shipment_information: '入仓信息',
  i18n_shipment_information1: '预约信息',
  i18n_shipment_instruction: '补料',
  i18n_warehosue_received_date: '入仓确认日期',
  i18n_custom_clearance_method: '报关方式',
  i18n_customs_declaration: '买单',
  i18n_Tax_refund: '退税',
  i18n_no_receiving_information: '暂无收货信息',
  i18n_pickup_cargo_at_below_warehouse: '请到以下目的地仓库提取货物',
  i18n_forecast_weight_kgs: '预报重量(kgs)',
  i18n_forecast_volume_cbm: '预报体积(cbm)',
  i18n_forecast_quantity: '预报数量',
  i18n_actual_weight_kgs: '入仓重量(kgs)',
  i18n_actual_volume_cbm: '入仓体积(cbm)',
  i18n_actual_quantity: '入仓数量',
  i18n_package_details: '箱子详情',
  i18n_invoices_generated_time: '账单产生时间',
  i18n_invoice_status: '账单状态',
  i18n_cancelled: '已作废',
  i18n_Offline: '线下',
  i18n_check_payment_receipt: '查看水单',
  i18n_payment_information: '水单信息',
  i18n_upload_payment_receipt: '上传水单',
  i18n_ocean_freight_information: '海运信息',
  i18n_land_transportation_information: '陆运信息',
  i18n_Value_added_service: '增值服务',
  i18n_shipping_information: '托运信息',
  i18n_Shop_number: '商铺号',
  i18n_provide_accurate_quantity_value: '请根据实际情况填写商品数量和商品货值',
  i18n_more_consignee_information: '更多收货人信息',
  i18n_FBA_facility_warehosue_information: 'FBA仓库信息',
  i18n_Billing_Number: '帐单号',
  i18n_Go_to_pay: '去支付',
  i18n_Abandoned: '废弃',
  i18n_Image_Upload: '图片上传',
  i18n_Confirm_Upload: '确认上传',
  i18n_Up_to_6_JPG: '最多上传6张，仅限JPG/JPEG/PNG格式',
  i18n_Upload_successful: '上传成功',
  i18n_Exceeding_quantity_limit: '超出数量限制',
  i18n_void_bill_continue: '此操作将作废此账单, 是否继续?',
  i18n_discarded_in_financial_verification_payment_receipt: '线下支付成功，财务核实水单中，是否废弃？',
  i18n_no_quotation_contact_salesman: '暂无此线路报价，请联系业务员',
  i18n_no_track: '暂无轨迹信息,请重新输入订单号查询',
  i18n_natural_days: ' 个自然日',
  i18n_Inquiry_receipt: '查询回执',
  i18n_Confirmation_selection: '确认选择',
  i18n_Importing_boxes: '导入箱子',
  i18n_Click_line_select_address: '点击任意一行选择您的地址',
  i18n_product_value_bigger_0: '货值必须大于0',
  i18n_Warehouse_Code: '仓库代码',
  i18n_More_consignor_information: '更多发货人信息',
  i18n_Slogan: '数字物流联接世界',
  i18n_confirm_delete_address: '确定删除该联系人吗?',
  i18n_Please_choose_pick_up_time: '请选择上门提货时间',
  i18n_Please_select_pick_up_address: '请选择上门提货地址',
  i18n_Pickup_Information: '提货信息',
  i18n_Value_Added_Service_Fee: '增值服务费',
  i18n_Order_Status: '订单状态',
  i18n_Pickup_Status: '提货状态',
  i18n_warehouse_status: '集货仓状态',
  i18n_Booking_Status: '订舱状态',
  i18n_China_Hong_Kong_Status: '中港状态',
  i18n_Trunk_status: '干线状态',
  i18n_Customs_clearance_status: '清关状态',
  i18n_Distribution_Center_Status: '分拨中心状态',
  i18n_delivery_status: '派送状态',
  i18n_LCL_status: '拼柜状态',
  i18n_Cabinet_status: '调柜状态',
  i18n_from_x_currency: '{currency}{price}起',
  i18n_not_logged_in_login_first: '您还未登录，请先登录',
  i18n_hotline_number: '客服热线',
  i18n_cititrans: '亦邦（深圳）国际物流有限公司',
  i18n_customer_service: '前台电话',
  i18n_fax: '传真',
  i18n_WeChat_ID: '微信ID',
  i18n_Online_WeChat_Customer_service: '微信客服',
  i18n_scan_qr_code_for_service: '扫描二维码添加客服微信',
  i18n_Address: '地址',
  i18n_cititrans_address: '广东省深圳市龙华区鸿荣源天骏C座39楼01-05室',
  i18n_consignee_address: '收货地址',
  i18n_pecies_quantity_greater_than_0: '件数不能小于等于0',
  i18n_cant_exceed_250_to_0_cm: '不能超过250cm或小于0cm',
  i18n_Reservation_delivery_warehouse: '预约送仓仓库',
  i18n_Schedule_warehouse_delivery_start_time: '预约送仓开始时间',
  i18n_Schedule_warehouse_delivery_end_time: '预约送仓结束时间',
  i18n_Reservation_warehouse_delivery_number: '预约送仓号',
  i18n_Reservation_warehouse_template: '约仓模板',
  i18n_warehouse_receipt: '入仓单',
  i18n_no_sevice_add: '该线路暂无增值服务',
  i18n_no_service_add_continue: '该线路暂无增值服务，请点击下一步继续操作',
  i18n_More: '更多',
  i18n_Entrusted: '委托',
  i18n_Booking_status: '订舱状态',
  i18n_Shipping_Schedule_Status: '船期状态',
  i18n_box_no_image: '箱子{index}请上传商品图片',
  i18n_Image_upload: '图片上传',
  i18n_Preview: '预览',
  i18n_By_detail: '按明细',
  i18n_By_summary: '按汇总',
  i18n_Reference: '参考号',
  i18n_Estimate_inWarehouse_cost: '入仓预估费用',
  actual_fee_after_loading: '具体费用以实际装柜为准',
  i18n_Image_manage: '图片管理',
  i18n_Image_manage1: '所有箱子只能选择一种货物类型',
  i18n_non_electrified_flight: '不带电/不带磁/品名单一',
  i18n_domestic_flights: '国内飞航班',
  i18n_minimum_20kg: '单票最低消20KG',
  i18n_minimum_150kg: '单票最低消150KG',
  i18n_warehosue_information: '仓库信息',
  i18n_warehouse_dongguan: '东莞仓',
  i18n_warehouse_foshan: '佛山仓',
  i18n_warehouse_yiwu: '义乌仓',
  i18n_warehouse_air_sea: '空/海运',
  i18n_warehouse_sea: '海运',
  i18n_warehouse_dongguan_address: '广东省东莞市塘厦镇蛟乙塘石桥路 6 号工业园一楼 亦邦物流',
  i18n_warehouse_foshan_address: '佛山市南海区里水镇文教社区文教路51号大管家（文教仓）A栋103，亦邦国际仓库',
  i18n_warehouse_yiwu_address: '义乌市北苑街道四季路 1000 号京东亚洲 1 号电子产业园 2 号楼 2 楼 14 号门',
  i18n_warehouse_dongguan_contact: '联系：18925240918',
  i18n_warehouse_foshan_contact: '周阳军：18102806630/13126479218',
  i18n_warehouse_yiwu_contact: '方发敏：1569213657'
}



// WEBPACK FOOTER //
// ./src/plugins/i18n/lang/zh.js